import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';

export const CommonTestDataPage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Common Test Data</h1>
        <p className="text-gray-500">Link your NCUEE (Common Test) results.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>NCUEE Linkage</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="p-4 border rounded-md bg-gray-50 text-center">
            <p className="text-gray-600 mb-4">No Common Test data linked yet.</p>
            <Button>Link NCUEE Data</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
